import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Feather, User, LogOut, Menu, X } from "lucide-react";
import { useState } from "react";

export default function Nav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#0D0C0A]/85 border-b border-[rgba(217,180,114,0.1)]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo">
          <Feather className="w-5 h-5 text-[#D9B472]" strokeWidth={1.5} />
          <span className="font-serif-display text-xl tracking-wide text-[#F7F3EC]">Anonscribe<span className="text-[#D9B472]"> Archive</span></span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm">
          <Link to="/browse" className="text-[#A8A095] hover:text-[#F7F3EC] transition-colors duration-200" data-testid="nav-browse">Browse</Link>
          <Link to="/vault" className="text-[#A8A095] hover:text-[#F7F3EC] transition-colors duration-200" data-testid="nav-vault">Character Vault</Link>
          <Link to="/how-it-works" className="text-[#A8A095] hover:text-[#F7F3EC] transition-colors duration-200" data-testid="nav-how">How it works</Link>
          {user && user !== false ? (
            <>
              <Link to="/dashboard" className="text-[#A8A095] hover:text-[#F7F3EC] transition-colors duration-200" data-testid="nav-dashboard">Dashboard</Link>
              <div className="flex items-center gap-3 pl-6 border-l border-[rgba(217,180,114,0.15)]">
                <span className="font-mono-brass text-xs text-[#D9B472]" data-testid="nav-pseudonym">{user.pseudonym}</span>
                <button onClick={async () => { await logout(); nav("/"); }} className="text-[#A8A095] hover:text-[#F7F3EC] transition-colors duration-200" data-testid="nav-logout">
                  <LogOut className="w-4 h-4" />
                </button>
              </div>
            </>
          ) : (
            <>
              <Link to="/auth" className="btn-ghost-gold px-4 py-2 rounded-sm text-xs uppercase tracking-widest font-mono-brass" data-testid="nav-auth">Sign in</Link>
              <Link to="/auth?mode=register" className="btn-buy px-4 py-2 rounded-sm text-xs uppercase tracking-widest font-mono-brass font-semibold" data-testid="nav-sell">Sell Unfinished Work</Link>
            </>
          )}
        </nav>

        <button className="md:hidden text-[#F7F3EC]" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[rgba(217,180,114,0.1)] bg-[#0D0C0A]/95 backdrop-blur-xl px-5 py-4 space-y-3">
          <Link to="/browse" onClick={() => setOpen(false)} className="block text-[#A8A095]" data-testid="nav-browse-mobile">Browse</Link>
          <Link to="/vault" onClick={() => setOpen(false)} className="block text-[#A8A095]" data-testid="nav-vault-mobile">Character Vault</Link>
          <Link to="/how-it-works" onClick={() => setOpen(false)} className="block text-[#A8A095]">How it works</Link>
          {user && user !== false ? (
            <>
              <Link to="/dashboard" onClick={() => setOpen(false)} className="block text-[#A8A095]" data-testid="nav-dashboard-mobile">Dashboard</Link>
              <button onClick={async () => { await logout(); nav("/"); setOpen(false); }} className="text-[#A8A095]" data-testid="nav-logout-mobile">Sign out</button>
            </>
          ) : (
            <>
              <Link to="/auth" onClick={() => setOpen(false)} className="block text-[#D9B472]" data-testid="nav-auth-mobile">Sign in</Link>
              <Link to="/auth?mode=register" onClick={() => setOpen(false)} className="block btn-buy px-4 py-2 rounded-sm text-xs uppercase tracking-widest font-mono-brass text-center">Sell Unfinished Work</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
